<!-- 
程式：GroupMemberNew.vue
功能：群組成員編輯
作者：i9400538 陳博承
完成：2021-05-07
-->
<template>
  <main class="container-fluid" :class="{'boxPadding': isBox}">
    <form class="form">
      <section class="segment segment-padding">
        <a
          v-show="grp_id"
          role="button"
          class="btn btn-default float-right m-0"
          @click="beforeDel"
        >刪除此群組</a>
        <h4 class="text-green">群組名稱</h4>
        <div class="row">
          <div class="col-12">
            <div class="form-group row">
              <div class="col-10 d-flex">
                <input
                  type="text"
                  maxlength="20"
                  id="group-name"
                  placeholder="請輸入群組名稱"
                  class="form-control"
                  v-model="groupName"
                  alt="ch"
                  @input="checkGroupName"
                  @blur="checkGroupName"
                />
              </div>
              <span class="waring-block d-inline-block ml-2">
                <span class="text">
                  <span class="text-red">＊</span>必填
                </span>
              </span>
            </div>
          </div>
        </div>
      </section>
      <section class="segment segment-padding">
        <h4 class="text-green">請選擇想加入此群組的客戶</h4>
        <div class="row">
          <div class="col-12">
            <div class="input-group input-lg">
              <div class="input">
                <input
                  type="text"
                  id="Search"
                  class="form-control"
                  maxlength="20"
                  v-model="currentKeyword"
                  @keydown.enter="doSearch()"
                  placeholder="輸入姓名、身分證進行搜尋..."
                  alt="ch"
                />
                <span id="searchclear" v-show="currentKeyword" @click="clearSearch()">清除</span>
              </div>
              <button type="button" class="btn btn-primary btn-icon" @click.prevent="doSearch()">
                <i class="icon-search i-24"></i>
              </button>
            </div>
          </div>
        </div>

        <!--radio區塊-->
        <div class="radio radio-inline">
          <input type="radio" v-model="type" id="r1" value="1" @change="handleRadioChange"/>
          <label for="r1">全部</label>
        </div>
        <div class="radio radio-inline">
          <input type="radio" v-model="type" id="r2" value="2" @change="handleRadioChange"/>
          <label for="r2">未加入任何群組</label>
        </div>
        <div class="radio radio-inline">
          <input type="radio" v-model="type" id="r3" value="3" @change="handleRadioChange"/>
          <label for="r3">已選擇({{ selection.length }})</label>
        </div>
        <div class="radio radio-inline" v-show="type=='1'">
          <label class="text-red">※已加入10個群組的客戶將不會顯示</label>
        </div>

        <!--全部資料區塊-->
        <div class="row" v-show="type=='1'">
          <section class="w-100">
            <table
              id="all_data_datatable"
              class="group-table table datatable table-striped table-bordered"
              ref="allDataTable"
            >
              <thead>
                <tr>
                  <th width="130px">
                    <div class="checkbox checkbox-inline mr-0">
                      <input
                        ref="checkAll"
                        type="checkbox"
                        v-model="checkAll"
                        @click="setCheckAll(!checkAll)"
                      />
                      <label @click="$refs.checkAll.click()"></label>
                    </div>#
                  </th>
                  <th
                    id="name_col"
                    :class="'sorting ' + (order.fieldName == 'name' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                    @click="processCustList('unsel', 'name')"
                  >姓名</th>
                  <th
                    id="id_col"
                    :class="'sorting ' + (order.fieldName == 'showid' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                    @click="processCustList('unsel', 'showid')"
                  >身分證</th>
                  <th
                    id="birthday_col"
                    ref="lastCol"
                    :class="'sorting ' + (order.fieldName == 'birthday' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                    @click="processCustList('unsel', 'birthday')"
                  >生日</th>
                </tr>
              </thead>
              <tbody
                id="unsel"
                @scroll="scrollmethod"
                v-if="tableData.length"
                :style="`height: ${dt_unsel_height}px`"
              >
                <tr
                  v-for="(item, index) in tableData"
                  :key="`td-unselected-${index}-${item.identity}`"
                >
                  <td width="130px">
                    <div class="checkbox checkbox-inline mr-0">
                      <input
                        @click="addItem(item)"
                        type="checkbox"
                        :id="`unselected-check-${index}`"
                        :value="item"
                        v-model="selection"
                      />
                      <label :for="`unselected-check-${index}`"></label>
                    </div>
                    <span class="no">{{index + 1}}</span>
                    <span class="info text-center">
                      <avatar :gender="Number(item.gender)" :size="20" />
                    </span>
                  </td>
                  <td>
                    <Tooltip
                      :position="index < 3 ? 'bottom' : 'top'"
                      :name="item.name"
                      :id="item.showid"
                      :birthday="item.birthday"
                    >
                      <a
                        @click.prevent="toCustDetail(item.identity, item.name)"
                        class="link text-underline"
                      >{{item.name | getMaskName}}</a>
                    </Tooltip>
                  </td>
                  <td>{{item.showid | getMaskID}}</td>
                  <td :width="iPadWidth">
                    <div class="date">{{item.birthday | dateFormat | getMaskBirthday}}</div>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="4" class="empty">
                    <h3 class="text-center py-5">查無資料，請確認您輸入之資料是否正確</h3>
                  </td>
                  <td v-show="false"></td>
                  <td v-show="false"></td>
                  <td v-show="false"></td>
                </tr>
              </tbody>
            </table>
          </section>
        </div>
        <!--未加入任何群組區塊-->
        <div class="row" v-show="type=='2'">
          <section class="w-100">
            <table
              id="no_group_datatable"
              class="group-table table datatable table-striped table-bordered"
              ref="noGroupDataTable"
            >
              <thead>
                <tr>
                  <th width="130px">
                    <div class="checkbox checkbox-inline mr-0">
                      <input
                        ref="checkAll_noGroup"
                        type="checkbox"
                        v-model="checkAll_noGroup"
                        @click="setCheckAll_noGroup(!checkAll_noGroup)"
                      />
                      <label @click="$refs.checkAll_noGroup.click()"></label>
                    </div>#
                  </th>
                  <th
                    id="col_nogroup_name"
                    :class="'sorting ' + (order_nogroup.fieldName == 'name' ? (order_nogroup.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                    @click="processCustList('nogroup', 'name')"
                  >姓名</th>
                  <th
                    id="col_nogroup_id"
                    :class="'sorting ' + (order_nogroup.fieldName == 'showid' ? (order_nogroup.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                    @click="processCustList('nogroup', 'showid')"
                  >身分證</th>
                  <th
                    id="col_nogroup_birthday"
                    :class="'sorting ' + (order_nogroup.fieldName == 'birthday' ? (order_nogroup.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                    @click="processCustList('nogroup', 'birthday')"
                  >生日</th>
                </tr>
              </thead>
              <tbody
                id="nogroup"
                @scroll="scrollmethod"
                v-if="noGroupList.length"
                :style="`height: ${dt_nogroup_height}px`"
              >
                <tr
                  v-for="(item, index) in noGroupList"
                  :key="`td-nogroup-${index}-${item.identity}`"
                >
                  <td width="130px">
                    <div class="checkbox checkbox-inline mr-0">
                      <input
                        @click="addItem(item, index)"
                        type="checkbox"
                        :id="`nogroup-check-${index}`"
                        :value="item"
                        v-model="selection"
                      />
                      <label :for="`nogroup-check-${index}`"></label>
                    </div>
                    <span class="no">{{index + 1}}</span>
                    <span class="info text-center">
                      <avatar :gender="Number(item.gender)" :size="20" />
                    </span>
                  </td>
                  <td>
                    <Tooltip
                      :position="index < 3 ? 'bottom' : 'top'"
                      :name="item.name"
                      :id="item.showid"
                      :birthday="item.birthday"
                    >
                      <a
                        @click.prevent="toCustDetail(item.identity, item.name)"
                        class="link text-underline"
                      >{{item.name | getMaskName}}</a>
                    </Tooltip>
                  </td>
                  <td>{{item.showid | getMaskID}}</td>
                  <td :width="iPadWidth">
                    <div class="date">{{item.birthday | dateFormat | getMaskBirthday}}</div>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="4" class="empty">
                    <h3 class="text-center py-5">查無資料，請確認您輸入之資料是否正確</h3>
                  </td>
                  <td v-show="false"></td>
                  <td v-show="false"></td>
                  <td v-show="false"></td>
                </tr>
              </tbody>
            </table>
          </section>
        </div>
        <!--已選擇資料區塊-->
        <div class="row" v-show="type=='3'">
          <section class="w-100">
            <table
              id="selected_data_datatable"
              class="group-table table datatable table-striped table-bordered"
              ref="selectionTable"
            >
              <thead>
                <tr>
                  <th width="130px">
                    <div class="checkbox checkbox-inline mr-0">
                      <input
                        ref="cancelAll"
                        type="checkbox"
                        v-model="cancelAll"
                        @click="setCancelAll(cancelAll)"
                      />
                      <label @click="$refs.cancelAll.click()"></label>
                    </div>#
                  </th>
                  <th
                    id="col_sel_name"
                    :class="'sorting ' + (order_sel.fieldName == 'name' ? (order_sel.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                    @click="processCustList('sel', 'name')"
                  >姓名</th>
                  <th
                    id="col_sel_id"
                    :class="'sorting ' + (order_sel.fieldName == 'showid' ? (order_sel.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                    @click="processCustList('sel', 'showid')"
                  >身分證</th>
                  <th
                    id="col_sel_birthday"
                    :class="'sorting ' + (order_sel.fieldName == 'birthday' ? (order_sel.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                    @click="processCustList('sel', 'birthday')"
                  >生日</th>
                </tr>
              </thead>
              <tbody
                id="sel"
                @scroll="scrollmethod"
                v-if="showList.length"
                :style="`height: ${dt_sel_height}px`"
              >
                <tr
                  v-for="(item, index) in showList"
                  :key="`td-selected-${index}-${item.identity}`"
                >
                  <td width="130px">
                    <div class="checkbox checkbox-inline mr-0">
                      <input
                        @click="removeItem(item, index)"
                        type="checkbox"
                        :id="`selected-check-${index}`"
                        :value="item"
                        v-model="selection"
                      />
                      <label :for="`selected-check-${index}`"></label>
                    </div>
                    <span class="no">{{index + 1}}</span>
                    <span class="info text-center">
                      <avatar :gender="Number(item.gender)" :size="20" />
                    </span>
                  </td>
                  <td>
                    <Tooltip
                      :position="index < 3 ? 'bottom' : 'top'"
                      :name="item.name"
                      :id="item.showid"
                      :birthday="item.birthday"
                    >
                      <a
                        @click.prevent="toCustDetail(item.identity, item.name)"
                        class="link text-underline"
                      >{{item.name | getMaskName}}</a>
                    </Tooltip>
                  </td>
                  <td>{{item.showid | getMaskID}}</td>
                  <td :width="iPadWidth">
                    <div class="date">{{item.birthday | dateFormat | getMaskBirthday}}</div>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="4" class="empty">
                    <h3 class="text-center py-5">查無資料，請確認您輸入之資料是否正確</h3>
                  </td>
                  <td v-show="false"></td>
                  <td v-show="false"></td>
                  <td v-show="false"></td>
                </tr>
              </tbody>
            </table>
          </section>
        </div>
      </section>
    </form>

    <!--浮動區塊 -->
    <section class="container-fluid">
      <fixed-botton v-show="!isScroll">
        <template slot="@function">
          <div>
            <button type="button" class="btn btn-default" @click="cancel">取消</button>
            <button type="button" class="btn btn-primary mr-0" @click="save">儲存</button>
          </div>
        </template>
      </fixed-botton>
    </section>

    <!--確認視窗 -->
    <warning-modal
      :open="warningModalOpen"
      message="請確認是否刪除該群組及群組成員 ?"
      @close="panelClose('warningModalOpen')"
      @submit="deleteGroup"
    />

    <!-- 打開遮罩 -->
    <mxMask :open="mxMaskOpen" />
  </main>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { commonMixin } from "@/mixins/common";
import { setTimeout } from "timers";
//component
import FixedBotton from "@/desktop/components/fixedBotton";
import Avatar from "@/desktop/components/Avatar";
import Tooltip from "@/desktop/components/ToolTip";
import mxMask from "@/desktop/components/mxMask";
import WarningModal from "@/desktop/components/WarningModal";
//service
import {
  getCustomers,
  getCustBy10Groups,
  updateGroup,
  updateGrpMem,
  removeGrp,
  getCustWithoutGroup
} from "@/service";
//parameter
const is_iPad = navigator.userAgent.match(/iPad/i) != null; // 確認裝置是否為 iPad

export default {
  name: "GroupMemberNew",
  mixins: [commonMixin],
  components: {
    FixedBotton,
    Avatar,
    Tooltip,
    mxMask,
    WarningModal
  },
  data() {
    return {
      grp_id: "",
      allData: [],
      tableData: [],
      selection: [],
      showList: [],
      selectedData: [],
      groupName: "",
      isShowAll: true,
      currentKeyword: "",
      keyword: "",
      checkAll: false,
      checkAll_noGroup: false,
      cancelAll: false, //取消全選
      dt_unsel_height: 0, //DataTable高度(未選擇區塊)
      dt_sel_height: 0, //DataTable高度(已選擇區塊)
      dt_nogroup_height: 0, //DataTable高度(未加入任何群組)
      order: {
        fieldName: "name",
        asc: true
      },
      order_sel: {
        fieldName: "name",
        asc: true
      },
      order_nogroup: {
        fieldName: "name",
        asc: true
      },
      mxMaskOpen: false,
      isScroll: false, //是否滾動
      scrollPostion: 25, // 顯示當前位置
      scrollPostionOffset: 10, // 1次render筆數
      // isToBottom: false, // 是否捲動到最下面
      // isToBottom_sel: false, // 是否捲動到最下面
      // isToBottom_noGroup: false, // 是否捲動到最下面
      // nowTime: 0,
      // lastTime: 0,
      iPadWidth: 364,
      warningModalOpen: false,
      type: "1", //radio切換用
      noGroupData: [], //未加入任何群組的客戶
      noGroupList: [], //未加入任何群組的客戶 (顯示用)
      isSearching: false,
      itemsPerPage: 50, // 每頁顯示多少筆資料
      currentPage: 0, // 當前顯示的頁碼
      isSearchingAllData: [],
      isSearchingNogroupData: [],
      isSearchingSelection: [],
    };
  },
  watch: {
    tableData() {
      this.registerHanlink();
    },
    // 清除關鍵字
    currentKeyword(newVal) {
      this.currentKeyword = this.cleanSpecialChar(newVal);
      if (!newVal) {
        this.clearSearch();
      }
    },
    // 切換radio
    type: function(val) {
      if (this.checkAll) {
        this.checkAll = false;
      }
      if (this.checkAll_noGroup) {
        this.checkAll_noGroup = false;
      }
      if (this.isSearching) {
        this.doSearch();
      }
      if (val == "3") {
        this.cancelAll = this.showList && this.showList.length > 0;
      }
      this.registerHanlink();
    },
    selection: function() {
      this.registerHanlink();
    }
  },
  computed: {
    ...mapGetters(["BaseUrl", "UserInfo"]),
    isBox() {
      return this.UserInfo.userType === "box";
    }
  },
  methods: {
    ...mapActions(["setPageLock", "updateCustID"]),
    clearSearch() {
      this.isSearching = false;
      this.keyword = this.currentKeyword = "";
      if (this.tableData && this.tableData.length != this.allData.length) {
        this.tableData = [...this.allData];
      }
      if (
        this.noGroupList &&
        this.noGroupList.length != this.noGroupData.length
      ) {
        this.noGroupList = [...this.noGroupData];
      }
      this.showList = [...this.selection];
      this.resetScrollTop()
      this.currentPage = 0;
      this.updateTableDisplayData()
      this.registerHanlink();
    },
    doSearch() {
      this.keyword = this.currentKeyword;
      this.isSearching = this.currentKeyword.trim() ? true : false;
      if (this.type == "1") {
        //搜尋全部區塊
        if (this.keyword.trim() != "") {
          this.isSearchingAllData = this.allData.filter(item => {
            const t = item.name.toUpperCase();
            const s = this.keyword.toUpperCase();
            return t.includes(s) || this.ToDBC(t).includes(this.ToDBC(s));
          });
          if (this.isSearchingAllData.length == 0) {
            this.isSearchingAllData = this.allData.filter(item => {
              const t = item.identity.toUpperCase();
              const s = this.keyword.toUpperCase();
              return t.includes(s) || this.ToDBC(t).includes(this.ToDBC(s));
            });
          }
        } else {
          this.tableData = [...this.allData];
        }

        //如果已選擇區塊有資料，篩選結果也有資料，比對篩選結果是否都出現在已選擇資料內
        if (
          !this.checkAll &&
          this.selection &&
          this.selection.length > 0 &&
          this.isSearchingAllData &&
          this.isSearchingAllData.length > 0
        ) {
          let flag = true;
          this.isSearchingAllData.forEach(item => {
            let findIndex = this.selection.indexOf(item);
            if (findIndex === -1) {
              flag = false;
              return;
            }
          });
          this.checkAll = flag;
        }
      } else if (this.type == "2") {
        //搜尋未加入任何群組區塊
        if (this.keyword.trim() != "") {
          this.isSearchingNoGroupData = this.noGroupData.filter(item => {
            const t = item.name.toUpperCase();
            const s = this.keyword.toUpperCase();
            return t.includes(s) || this.ToDBC(t).includes(this.ToDBC(s));
          });
          if (this.isSearchingNoGroupData.length == 0) {
            this.isSearchingNoGroupData = this.noGroupData.filter(item => {
              const t = item.identity.toUpperCase();
              const s = this.keyword.toUpperCase();
              return t.includes(s) || this.ToDBC(t).includes(this.ToDBC(s));
            });
          }
        } else {
          this.noGroupList = [...this.noGroupData];
        }

        //如果已選擇區塊有資料，篩選結果也有資料，比對篩選結果是否都出現在已選擇資料內
        if (
          !this.checkAll_noGroup &&
          this.selection &&
          this.selection.length > 0 &&
          this.isSearchingNoGroupData &&
          this.isSearchingNoGroupData.length > 0
        ) {
          let flag = true;
          this.isSearchingNoGroupData.forEach(item => {
            let findIndex = this.selection.indexOf(item);
            if (findIndex === -1) {
              flag = false;
              return;
            }
          });
          this.checkAll_noGroup = flag;
        }
      } else {
        //搜尋已選擇區塊
        if (this.keyword.trim() !== "" && this.selection.length > 0) {
          this.isSearchingSelection = this.selection.filter(item => {
            const t = item.name.toUpperCase();
            const s = this.keyword.toUpperCase();
            return t.includes(s) || this.ToDBC(t).includes(this.ToDBC(s));
          });
          if (this.isSearchingSelection.length == 0) {
            this.isSearchingSelection = this.selection.filter(item => {
              const t = item.identity.toUpperCase();
              const s = this.keyword.toUpperCase();
              return t.includes(s) || this.ToDBC(t).includes(this.ToDBC(s));
            });
          }
        } else {
          //顯示現有已選擇資料
          this.showList = [...this.selection];
        }
      }

      this.resetScrollTop()
      this.currentPage = 0;
      this.updateTableDisplayData()
      this.registerHanlink();
    },
    resetScrollTop(){
      this.$nextTick(() => {
        this.$refs.allDataTable.querySelector('#unsel').scrollTop = 0;
        this.$refs.noGroupDataTable.querySelector('#nogroup').scrollTop = 0;
        this.$refs.selectionTable.querySelector('#sel').scrollTop = 0;
      });
    },
    //半形轉化為全形
    ToDBC(str) {
      let result = "";
      let len = str.length;
      for (let i = 0; i < len; i++) {
        let cCode = str.charCodeAt(i);
        //全形與半形相差（除空格外）：65248(十進位制)
        cCode = cCode >= 0x0021 && cCode <= 0x007e ? cCode + 65248 : cCode;
        //處理空格
        cCode = cCode == 0x0020 ? 0x03000 : cCode;
        result += String.fromCharCode(cCode);
      }
      return result;
    },
    //挑選項目
    addItem(item) {
      let findIndex = this.checkItemIsExist(item, this.showList);
      if (findIndex === -1) {
        this.showList.push(item);
      } else {
        this.showList.splice(findIndex, 1);
      }
      if (this.checkAllClick) {
        this.checkAll = false;
      }
    },
    //移除所挑選項目
    removeItem(item, index) {
      let findIndex = this.checkItemIsExist(item, this.selection);
      if (findIndex !== -1) {
        this.selection.splice(findIndex, 1);
      }
      this.showList.splice(index, 1);
    },
    //欄位排序
    processCustList(col, fieldName) {
      let order =
        col == "unsel"
          ? this.order
          : col == "nogroup"
          ? this.order_nogroup
          : this.order_sel;
      if (order.fieldName == fieldName) {
        order.asc = !order.asc;
      } else {
        order.fieldName = fieldName;
        order.asc = true;
      }

      //data排序
      let sortOrder = -1;
      if (order.asc) {
        sortOrder = 1;
      }

      switch (fieldName) {
        case "birthday":
          setTimeout(() => {
            if (col == "unsel") {
              this.tableData.sort(this.dateCompareFun(sortOrder, fieldName));
            } else if (col == "nogroup") {
              this.noGroupList.sort(this.dateCompareFun(sortOrder, fieldName));
            } else {
              this.showList.sort(this.dateCompareFun(sortOrder, fieldName));
            }
            this.registerHanlink(); // 難字顯示
          }, 20);
          break;
        default:
          setTimeout(() => {
            if (col == "unsel") {
              this.tableData.sort(this.sortCompareFun(sortOrder, fieldName));
            } else if (col == "nogroup") {
              this.noGroupList.sort(this.sortCompareFun(sortOrder, fieldName));
            } else {
              this.showList.sort(this.sortCompareFun(sortOrder, fieldName));
            }
            this.registerHanlink(); // 難字顯示
          }, 20);
      }
    },
    sortCompareFun(sortOrder, property) {
      return function(a, b) {
        let result =
          a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
        return result * sortOrder;
      };
    },
    //日期排序
    dateCompareFun(sortOrder, property) {
      return function(a, b) {
        let date_a = new Date(
          a[property] ? a[property] : "1880-01-01"
        ).getTime();
        let date_b = new Date(
          b[property] ? b[property] : "1880-01-01"
        ).getTime();
        let result = date_a < date_b ? -1 : 1;
        return result * sortOrder;
      };
    },
    //初始化
    init() {
      this.mxMaskOpen = true; //開啟遮罩
      this.grp_id = this.$route.params.grp_id || ""; //群組ID, 若為編輯狀態則有值
      this.groupName = this.$route.params.grp_name || ""; //群組名稱, 若為編輯狀態則有值
      this.selectedData = this.$route.params.custsOfGrp || []; //群組成員, 若為編輯狀態則有值
      //取得客戶列表
      getCustomers(
        this.$store.state.userInfo.id,
        "",
        "1",
        "1",
        "1",
        "1",
        "1",
        "1"
      ).then(result => {
        if (
          result.header &&
          result.header.status === "200" &&
          result.body.customer_list &&
          result.body.customer_list.length > 0
        ) {
          this.allData = result.body.customer_list.map(item => {
            let identity = item.id || item.ser_no || ""; //有ID取id(身分證)、無ID則取ser_no(流水號)
            return {
              name: item.name || "",
              gender: item.sex || Number(identity[1]) || "", //性別
              identity: identity,
              birthday: item.birthday || "",
              showid: item.id || ""
            };
          });
          //取得未加入任何群組的客戶
          getCustWithoutGroup(this.$store.state.userInfo.id).then(res => {
            if (res.header && res.header.status === "200" && res.body.result) {
              this.noGroupData = res.body.result.map(item => {
                let showid = item.id.startsWith("~") ? "" : item.id; //有ID取id(身分證)、無ID則不顯示
                return {
                  name: item.name || "",
                  gender: item.sex || Number(item.id[1]) || "", //性別
                  identity: item.id,
                  birthday: item.birthday || "",
                  showid: showid || ""
                };
              });
              this.noGroupList = [...this.noGroupData];
              //取得已存在10個群組的客戶
              getCustBy10Groups(this.$store.state.userInfo.id).then(res => {
                this.mxMaskOpen = false; //關閉遮罩
                if (
                  res.header &&
                  res.header.status === "200" &&
                  res.body.customers
                ) {
                  let over10groupsList = res.body.customers
                    ? res.body.customers
                    : [];
                  if (over10groupsList && over10groupsList.length > 0) {
                    if (this.selectedData && this.selectedData.length > 0) {
                      this.selectedData.forEach(sel => {
                        let theIndex = this.checkItemIsExist(
                          sel,
                          over10groupsList
                        );
                        if (theIndex !== -1) {
                          over10groupsList.splice(theIndex, 1);
                        }
                      });
                    }
                    let filterList = this.allData.filter(data => {
                      return over10groupsList.indexOf(data.identity) === -1;
                    });
                    this.allData = filterList; //過濾掉已加入10個群組的客戶
                  }
                }

                this.updateTableDisplayData();
                //this.tableData = [...this.allData];
              });
            }
          });
        } else {
          this.mxMaskOpen = false; //關閉遮罩
          this.tableData = [];
        }
        this.selection = [...this.selectedData];
        this.showList = [...this.selectedData];
        this.cancelAll = this.showList && this.showList.length > 0;
      });
      //卷軸位置初始化
      this.resetPosition();
    },
    //滾動顯示/隱藏
    // handleScroll() {
    //   this.isScroll = true;
    //   clearTimeout(this.scrolltimeOutProcessId);
    //   this.scrolltimeOutProcessId = setTimeout(() => {
    //     this.isScroll = false;
    //   }, 500);
    // },
    // 切換radio時重置頁碼並更新table顯示資料
    handleRadioChange(){
      this.currentPage = 0;
      this.updateTableDisplayData();
    },
    //DataTable滾動事件
    scrollmethod(e) {  
      this.isScroll = true;
      clearTimeout(this.scrolltimeOutProcessId);
      this.scrolltimeOutProcessId = setTimeout(() => {
        this.isScroll = false;
      }, 100);
      
      const { scrollTop, clientHeight, scrollHeight } = e.target;

      if (scrollTop + clientHeight >= scrollHeight - 50) {
        this.currentPage++;
        this.updateTableDisplayData(); // 加載更多資料
      }
      /*
      const scrollTop = e.target.scrollTop;
      const clientHeight = e.target.clientHeight;
      const scrollHeight = e.target.scrollHeight;
      this.nowTime = +new Date();
      if (this.nowTime > this.lastTime + 150) {
        this.lastTime = this.nowTime;
        const tempPostion = scrollTop / 69 + this.scrollPostionOffset;
        this.scrollPostion = Math.max(this.scrollPostion, tempPostion);
        let type = e.target.id; //捲動的表格 unsel(可選擇表格) / sel(已選擇表格)
        let isBottom =
          "unsel" == type
            ? this.isToBottom
            : "nogroup" == type
            ? this.isToBottom_noGroup
            : this.isToBottom_sel;
        if (!isBottom) {
          if (  scrollHeight - scrollTop - clientHeight <= 50 ) {
            //當滾動卷軸接近底端，縮小表格高度
            if (is_iPad) {
              if ("unsel" == type) {
                this.dt_unsel_height = $(window).height() - 500;
              } else if ("nogroup" == type) {
                this.dt_nogroup_height = $(window).height() - 500;
              } else {
                this.dt_sel_height = $(window).height() - 500;
              }
            } else {
              if ("unsel" == type) {
                this.dt_unsel_height = $(window).height() - 570;
              } else if ("nogroup" == type) {
                this.dt_nogroup_height = $(window).height() - 570;
              } else {
                this.dt_sel_height = $(window).height() - 570;
              }
            }
            //設定是否滾到最底端判斷
            if ("unsel" == type) {
              this.isToBottom = true;
            } else if ("nogroup" == type) {
              this.isToBottom_noGroup = true;
            } else {
              this.isToBottom_sel = true;
            }
          }
        }
      }
        */
    },
    updateTableDisplayData() {
      const start = this.currentPage * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      if(this.isSearching){
          if(this.type == 1){
            this.tableData = this.isSearchingAllData.slice(0, end); 
          }else if(this.type == 2){
            this.noGroupList = this.isSearchingNoGroupData.slice(0, end); 
          }else if(this.type == 3){
            this.showList = this.isSearchingSelection.slice(0, end); 
          }   
      }else{
          if(this.type == 1){
            this.tableData = this.allData.slice(0, end); 
          }else if(this.type == 2){
            this.noGroupList = this.noGroupData.slice(0, end); 
          }else if(this.type == 3){
            this.showList = this.selection.slice(0, end); 
          }    
      } 
    },
    //畫面初始化(卷軸, 表格高度)
    resetPosition() {
      this.scrollPostion = 25;
      this.scrollPostionOffset = 10;
      let height = $(window).height() - 290;
      this.dt_unsel_height = height;
      this.dt_nogroup_height = height;
      this.dt_sel_height = height;
    },
    //儲存
    save() {
      if (!this.groupName || this.groupName.trim() == "") {
        this.$toast.info({ title: "群組名稱不可為空" });
        return;
      }
      if (this.grp_id) {
        //修改群組(有傳入grp_id)
        let editList = [];
        this.selection.forEach(item => {
          editList.push(item.identity);
        });
        updateGrpMem(
          this.$store.state.userInfo.id,
          this.grp_id,
          this.groupName,
          editList
        ).then(result => {
          if (result.header.status && result.header.status == "200") {
            this.$toast.info({ title: result.header.message });
            this.cancel(); //修改成功後，導頁到群組管理頁面
          } else {
            this.$toast.info({ title: result.header.message });
          }
        });
      } else {
        //新增群組
        updateGroup(
          this.$store.state.userInfo.id,
          null,
          this.groupName,
          this.selection
        ).then(result => {
          if (result.header.status && result.header.status == "200") {
            this.$toast.info({ title: result.header.message });
            this.cancel(); //新增成功後，導頁到群組管理頁面
          } else {
            this.$toast.info({ title: result.header.message });
          }
        });
      }
    },
    //取消
    cancel() {
      this.$router.push({ name: "group" });
    },
    //刪除確認
    beforeDel() {
      this.warningModalOpen = true;
    },
    //刪除群組
    deleteGroup() {
      removeGrp(
        this.$store.state.userInfo.id,
        this.$store.state.userInfo.id,
        this.grp_id
      ).then(result => {
        if (result.header.status === "200") {
          this.$toast.info({ title: result.header.message });
          this.cancel(); //刪除成功後，導頁到群組管理頁面
        } else {
          this.$toast.info({ title: result.header.message });
        }
      });
    },
    //檢查群組名稱
    checkGroupName() {
      this.groupName = this.cleanSpecialChar(this.groupName, '@()_');
    },
    //欄位寬度初始化
    initColWidth() {
      if (!is_iPad) {
        this.iPadWidth = this.$refs.lastCol.clientWidth - 15;
      } else {
        this.iPadWidth = this.$refs.lastCol.clientWidth;
      }
    },
    //連到客戶個人資訊頁面
    toCustDetail(custId, custName) {
      if (this.isBox) {
        this.boxCustInfo(custId, custName);
      } else {
        this.updateCustID(custId);
        localStorage.CustID = custId;
        this.$router.push({ path: `/detail/CustID/tab/1` });
      }
    },
    //全選
    setCheckAll(val) {
      if (val) {
        this.mxMaskOpen = true; //開啟遮罩
        setTimeout(() => {
          this.tableData.forEach(item => {
            if (this.checkItemIsExist(item, this.selection) === -1) {
              this.selection.push(item);
              this.showList.push(item);
            }
          });
          this.mxMaskOpen = false;
        }, 20);
      } else {
        this.tableData.forEach(item => {
          let findIndex = this.checkItemIsExist(item, this.selection);
          if (findIndex !== -1) {
            this.selection.splice(findIndex, 1);
            this.showList.splice(findIndex, 1);
          }
        });
      }
    },
    //全選(未加入任何群組的客戶)
    setCheckAll_noGroup(val) {
      if (val) {
        this.mxMaskOpen = true; //開啟遮罩
        setTimeout(() => {
          this.noGroupList.forEach(item => {
            if (this.checkItemIsExist(item, this.selection) === -1) {
              this.selection.push(item);
              this.showList.push(item);
            }
          });
          this.mxMaskOpen = false;
        }, 20);
      } else {
        this.noGroupList.forEach(item => {
          let findIndex = this.checkItemIsExist(item, this.selection);
          if (findIndex !== -1) {
            this.selection.splice(findIndex, 1);
            this.showList.splice(findIndex, 1);
          }
        });
      }
    },
    //取消全選
    setCancelAll(val) {
      if (val) {
        this.showList.forEach(item => {
          let findIndex = this.checkItemIsExist(item, this.selection);
          if (findIndex !== -1) {
            this.selection.splice(findIndex, 1);
          }
        });
        this.showList = [];
      }
    },
    //檢查元素是否存在，無元素回傳-1 / 有元素回傳位置
    checkItemIsExist(item, list) {
      return list
        .map(function(e) {
          return e.identity ? e.identity : e;
        })
        .indexOf(item.identity);
    }
  },
  mounted() {
    this.initColWidth();
    //window.addEventListener("scroll", this.handleScroll, true);
    this.init();
    let self = this;
    $(window).bind("orientationchange", function(event) {
      $(window).one("resize", function() {
        self.dt_unsel_height = $(window).height() - 310;
        self.dt_sel_height = $(window).height() - 310;
        self.iPadWidth = self.$refs.lastCol.clientWidth;
        this.initColWidth();
      });
    });
  }
};
</script>

<style lang="scss" scoped>
#searchclear {
  position: absolute;
  right: 20px;
  top: 16px;
  bottom: 0;
  margin-right: 58px;
  cursor: pointer;
  font-size: 15px;
  color: #048f3a;
  text-decoration: underline;
}

::placeholder {
  line-height: normal;
}

.group-table thead tr,
.group-table tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.group-table tbody {
  display: block;
  height: 350px;
  overflow-y: scroll;
  border: 0 !important;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 17px;
    border: 0;
    box-shadow: none;
  }

  &::-webkit-scrollbar-track {
    box-shadow: none;
    border-radius: 0px;
    border: 0;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    width: 10px;
    border-radius: 20px;
    background-color: #555;
  }

  &.sorting,
  &.sorting_desc {
    position: relative;
    padding-right: 25px !important;

    &:before,
    &:after {
      content: "";
      position: absolute;
      width: 0px;
      height: 0px;
      display: block;
      top: 0;
      bottom: 0;
      right: 6px;
      margin: auto;
    }

    &:after {
      top: 18px;
      border-top: 6px solid transparentize(#027a39, 0.5);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-bottom: 6px solid transparent;
    }

    &:before {
      top: -13px;
      border-bottom: 6px solid transparentize(#027a39, 0.5);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 6px solid transparent;
    }
  }

  &.sorting_asc:before {
    border-bottom: 6px solid transparentize(white, 0.5);
  }

  &.sorting_desc:after {
    border-top: 6px solid transparentize(white, 0.5);
  }

  &.no-sort:before,
  &.no-sort:after {
    display: none;
  }
}

.boxPadding {
  padding-top: 0px !important;
}

.segment-padding {
  padding: 1px 40px 10px 40px;
}
</style>
